import { AppTableRowActions } from "../../../../components/AppTable/AppTableRowActions";
import { formatDate } from "../../../../utils/formatters/DateFormatter";
import { ClientListFields } from "../types";

interface ClientRowProps {
    client: ClientListFields;
    onDelete: (body: ClientListFields) => void;
    onView: (id: number) => void;
    t: (key: string) => string;
}
export function ClientRow({ client, onDelete, onView, t }: ClientRowProps) {
    console.log(client)
    return (
        <tr>
            <td style={{ verticalAlign: "middle" }}>
                <div>{client.id}</div>
            </td>
            <td style={{ verticalAlign: "middle" }}>
                <div>{client.name}</div>
            </td>
            <td style={{ verticalAlign: "middle" }}>
                <div>{client.documentNumber}</div>
            </td>
            <td style={{ verticalAlign: "middle" }}>
                <div>{formatDate(client.dataCreacio)}</div>
            </td>
            <td>
                <AppTableRowActions<ClientListFields>
                    object={client}
                    onDelete={onDelete}
                    onView={onView}
                    t={t}
                    typePermision="CLIENT_MANAGEMENT"
                />
            </td>
        </tr>
    );

}
